/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to create a line item match group
 * @export
 * @interface CreateLineItemMatchGroupRequest
 */
export interface CreateLineItemMatchGroupRequest {
    /**
     * ID of the comparison
     * @type {number}
     * @memberof CreateLineItemMatchGroupRequest
     */
    comparisonId: number;
    /**
     * ID of the parent room match group (required field, null allowed for unmatched rooms)
     * @type {number}
     * @memberof CreateLineItemMatchGroupRequest
     */
    roomMatchGroupId: number | null;
    /**
     * IDs of insurer line items to match
     * @type {Array<number>}
     * @memberof CreateLineItemMatchGroupRequest
     */
    insurerLineItemIds: Array<number>;
    /**
     * IDs of contractor line items to match
     * @type {Array<number>}
     * @memberof CreateLineItemMatchGroupRequest
     */
    contractorLineItemIds: Array<number>;
    /**
     * Confidence score for manual matches (optional)
     * @type {number}
     * @memberof CreateLineItemMatchGroupRequest
     */
    confidenceScore?: number;
    /**
     * User notes about this match
     * @type {string}
     * @memberof CreateLineItemMatchGroupRequest
     */
    note?: string;
}

/**
 * Check if a given object implements the CreateLineItemMatchGroupRequest interface.
 */
export function instanceOfCreateLineItemMatchGroupRequest(value: object): value is CreateLineItemMatchGroupRequest {
    if (!('comparisonId' in value) || value['comparisonId'] === undefined) return false;
    if (!('roomMatchGroupId' in value) || value['roomMatchGroupId'] === undefined) return false;
    if (!('insurerLineItemIds' in value) || value['insurerLineItemIds'] === undefined) return false;
    if (!('contractorLineItemIds' in value) || value['contractorLineItemIds'] === undefined) return false;
    return true;
}

export function CreateLineItemMatchGroupRequestFromJSON(json: any): CreateLineItemMatchGroupRequest {
    return CreateLineItemMatchGroupRequestFromJSONTyped(json, false);
}

export function CreateLineItemMatchGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLineItemMatchGroupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'comparisonId': json['comparisonId'],
        'roomMatchGroupId': json['roomMatchGroupId'],
        'insurerLineItemIds': json['insurerLineItemIds'],
        'contractorLineItemIds': json['contractorLineItemIds'],
        'confidenceScore': json['confidenceScore'] == null ? undefined : json['confidenceScore'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function CreateLineItemMatchGroupRequestToJSON(json: any): CreateLineItemMatchGroupRequest {
    return CreateLineItemMatchGroupRequestToJSONTyped(json, false);
}

export function CreateLineItemMatchGroupRequestToJSONTyped(value?: CreateLineItemMatchGroupRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comparisonId': value['comparisonId'],
        'roomMatchGroupId': value['roomMatchGroupId'],
        'insurerLineItemIds': value['insurerLineItemIds'],
        'contractorLineItemIds': value['contractorLineItemIds'],
        'confidenceScore': value['confidenceScore'],
        'note': value['note'],
    };
}

